// Bot protection (HasBotProtection): a <form wire:protect="{form}"> gets a reCAPTCHA v3 token just
// before it submits. Google's script loads on the first touch of such a form, so other pages never load it.
// When v3 scores someone low, the server sets $checkbox and the form shows the v2 "I'm not a robot" box
// (x-input.protection); its answer is sent instead.
const siteKey = () => document.querySelector('meta[name="recaptcha"]')?.content;
const checkboxKey = () => document.querySelector('meta[name="recaptcha-checkbox"]')?.content;

let loading = null;

function load() {
    if (!siteKey()) {
        return Promise.resolve(null);
    }

    return loading ??= new Promise((resolve) => {
        const script = Object.assign(document.createElement('script'), {
            src: `https://www.google.com/recaptcha/api.js?render=${siteKey()}`,
            async: true,
        });
        script.onload = () => window.grecaptcha.ready(() => resolve(window.grecaptcha));
        script.onerror = () => {
            loading = null;
            resolve(null);
        };
        document.head.append(script);
    });
}

window.captchaCheckbox = async (box) => {
    const grecaptcha = await load();

    if (grecaptcha && checkboxKey() && box.dataset.widget === undefined) {
        box.dataset.widget = grecaptcha.render(box, { sitekey: checkboxKey(), theme: 'dark' });
    }
};

/** The ticked box's answer, once: the box is cleared for another try. */
function checkboxAnswer(form) {
    const widget = form.querySelector('[data-captcha-box]')?.dataset.widget;

    if (widget === undefined || !window.grecaptcha) {
        return '';
    }

    const answer = window.grecaptcha.getResponse(widget);
    window.grecaptcha.reset(widget);

    return answer;
}

async function token(action) {
    try {
        const grecaptcha = await load();

        return grecaptcha ? await grecaptcha.execute(siteKey(), { action }) : '';
    } catch {
        return '';  // the server says so, and the person can try again
    }
}

document.addEventListener('livewire:init', () => {
    Livewire.directive('protect', ({ el, directive, component }) => {
        // The form's own action, a method name: wire:submit="send"
        const submit = [...el.attributes].find((attribute) => attribute.name.startsWith('wire:submit'))?.value.trim();

        el.addEventListener('focusin', load, { once: true });

        el.addEventListener('submit', async (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            // Deferred: travels with the submit's own request
            component.$wire.captcha = component.$wire.checkbox ? checkboxAnswer(el) : await token(directive.expression);
            component.$wire.$call(submit);
        }, { capture: true });
    });
});
